import Loadable from '../../components/loadable';
import ModalPlaceholder from '../../components/modal_placeholder';

const BulkDeleteMakeupClasses = Loadable({
  loader: () => import('../../pages/reports/bulk_delete_makeup_classes/bulk_delete_makeup_classes'),
});

angular.module('gym').value('BulkDeleteMakeupClasses', BulkDeleteMakeupClasses);

const BulkDeleteMakeupClassesModal = Loadable({
  loader: () => import('../../pages/reports/bulk_delete_makeup_classes/bulk_delete_makeup_classes_modal'),
  loading: ModalPlaceholder,
});

angular.module('gym').value('BulkDeleteMakeupClassesModal', BulkDeleteMakeupClassesModal);

const BulkDeleteMakeupClassesFiltersModal = Loadable({
  loader: () => import('../../pages/reports/bulk_delete_makeup_classes/bulk_delete_makeup_classes_filters_modal'),
  loading: ModalPlaceholder,
});

angular.module('gym').value('BulkDeleteMakeupClassesFiltersModal', BulkDeleteMakeupClassesFiltersModal);
